<div class="project-sync-container" *ngIf="canSync">
  <!-- Main Sync Button -->
  <button
    mat-raised-button
    color="primary"
    class="sync-button"
    [disabled]="isLoading || (!unifierLinked && !isHierarchyContainer)"
    [matTooltip]="
      !unifierLinked && !isHierarchyContainer
        ? ('integration.project_not_linked_to_unifier' | transloco)
        : !unifierLinked && isHierarchyContainer
        ? getHierarchyText('tooltip')
        : ''
    "
    (click)="onSync()"
    [attr.aria-label]="'Sync ' + provider + ' from Unifier'"
  >
    <mat-icon class="sync-icon icon" [class.spinning]="isLoading" svgIcon="sync"></mat-icon>
    <span class="button-text">
      {{ isLoading ? ('integration.syncing' | transloco) : getLabel('syncButton') }}
    </span>
  </button>

  <!-- Last Sync Results Button -->
  <app-last-sync-results-button
    *ngIf="showLastResults"
    [provider]="provider"
    [projectId]="projectId"
    [disabled]="isLoading"
    (color)="_lastSyncResultsNotViewed() ? 'warn' : 'accent'"
    (resultsClicked)="onLastSyncResultsClicked($event)"
  ></app-last-sync-results-button>

  <!-- Last Sync Info -->
  <div class="sync-info" *ngIf="lastSyncTime">
    <mat-icon class="info-icon icon" svgIcon="schedule"></mat-icon>
    <span class="info-text">
      {{ 'integration.last_sync' | transloco }}: {{ formatDateByLocale(lastSyncTime) }}
    </span>
  </div>
</div>
